/**
 * App-level configuration constants.
 * Kept in one place so channel handles / support usernames / version can be
 * changed without touching components.
 */

/** The official Astral sticker-pack channel. */
export const ASTRAL_CHANNEL_USERNAME = 'AstralAtelier';

/** Build a canonical Telegram link for a username (strips a leading @). */
export function telegramLink(username: string): string {
  return `https://t.me/${username.replace(/^@/, '')}`;
}

export const APP_VERSION = '0.2.0';

/**
 * Support contact — reserved for a future phase. When set, the UI can surface a
 * "Contact support" link. Intentionally unused in the UI for now.
 */
export const SUPPORT_USERNAME: string | null = null;
